import { FC, useEffect, useRef } from 'react';
import {
  ImagesEnum,
  useImagesContext,
} from '../../../../../providers/StartProvider/ImagesProvider';
import { drawButton, drawObjects } from '../../utils/drawing';
import * as WinterItems from '../../items/winterItems';
import { pointsToDraw } from '../constants';
import { useSelector } from 'react-redux';
import { RootState } from '../../../../../stores';
import { useTranslation } from 'react-i18next';

type MainObjElSchoolProps = {
  className?: string;
};

const MainObjElSchool: FC<MainObjElSchoolProps> = ({ className }) => {
  const canvasRef = useRef<HTMLCanvasElement | null>(null);
  const drawBackground = (ctx: CanvasRenderingContext2D) => {
    ctx.fillStyle = '#2D396B';
  };
  const { t, i18n } = useTranslation(['translation']);
  const language = i18n.language;
  const { images, isLoaded, getImage } = useImagesContext();
  const currentSubjectId = useSelector(
    (state: RootState) => state.start.currentSubjectId
  );
  const subjectDetails = useSelector(
    (state: RootState) => state.start.subjectDetails
  );

  useEffect(() => {
    const canvas = canvasRef.current;
    if (canvas) {
      const ctx = canvas.getContext('2d');

      if (ctx && isLoaded) {
        ctx.imageSmoothingEnabled = false;
        canvas.width = 960;
        canvas.height = 960;
        drawBackground(ctx);

        drawObjects(ctx, pointsToDraw, images);
        const middleButton = getImage(ImagesEnum.MiddleButton);
        const buttonBackgroundImg = getImage(ImagesEnum.Button1);
        const lockClosedButtonImg = getImage(ImagesEnum.LockClosed);

        const subjectData = subjectDetails?.[language]?.find(
          (data) => data.subjectId === currentSubjectId
        );

        if (subjectData?.levelProgress === 1 && subjectData?.subjectLevel === 5) {
          drawButton(ctx, 436.7, 109.34, 86.7, 38.1, middleButton!);
        } else {
          drawButton(
            ctx,
            436.7,
            109.34,
            86.7,
            38.1,
            buttonBackgroundImg!,
            lockClosedButtonImg
          );
        }
      }
    }
  }, [isLoaded, images, getImage, t]);
  return (
    <div className={className}>
      <canvas
        className="scale-100 overflow-hidden"
        ref={canvasRef}
        width={960}
        height={960}
      ></canvas>
    </div>
  );
};

export default MainObjElSchool;
